<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-20 09:32:04
-->
<template>
  <div>
    <div class="maintitle" v-if="!isMobile">员工最终考核</div>
    <el-divider v-if="!isMobile"></el-divider>
    <div v-if="isMobile" class="text-left">
      <el-input v-model='keyword' placeholder="请输入搜索关键词" size='mini' class="margin-bottom"></el-input>
      <el-select v-model="crntStatus" size="mini" class="margin-bottom" @change="searchList" style="width:100%;">
        <el-option :value="0" label="全部"></el-option>
        <el-option :value="1" label="暂存"></el-option>
        <el-option :value="2" label="未审"></el-option>
        <el-option :value="9" label="完成"></el-option>
      </el-select>
      <el-row :gutter="10" class="margin-bottom">
        <el-col :span="12">
          <el-button @click="searchList" size='mini' style="width:100%;">筛选</el-button>
        </el-col>
        <el-col :span="12">
          <el-button @click="finish" size='mini' style="width:100%;">结束考核</el-button>
        </el-col>
      </el-row>
      <div class="margin-bottom" style="font-size: 12px;">
        <el-row :gutter="10">
          <el-col :span="12" v-if="leftNumber >0">
            <span>剩余{{ leftNumber }}人未提交</span>
            <span @click="showLeft" style='cursor:pointer;color:blue'>查看名单</span>
          </el-col>
          <el-col :span="12" v-if="votinglist.length>0">
            <span class="margin-left">{{ votinglist.length }}人未完成投票</span>
            <span @click="votingDiv=true" style='cursor:pointer;color:blue'>查看名单</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-row class="text-left" :gutter="10" v-else>
      <el-col :span='6'>
        <el-input v-model='keyword' placeholder="请输入搜索关键词" size='mini'
                  @keyup.enter.native="searchList"></el-input>
      </el-col>
      <el-select v-model="crntStatus" size="mini" class="margin-right" @change="searchList">
        <el-option :value="0" label="全部"></el-option>
        <el-option :value="1" label="暂存"></el-option>
        <el-option :value="2" label="未审"></el-option>
        <el-option :value="9" label="完成"></el-option>
      </el-select>
      <el-button @click="searchList" size='mini'>筛选</el-button>
      <el-button @click="finish" size='mini'>结束考核</el-button>
      <span v-if="leftNumber >0" style='font-size:12px'><span
          class="margin-left">剩余{{ leftNumber }}人未提交</span><span @click="showLeft"
                                                                       style='cursor:pointer;color:blue'>查看名单</span>；</span>
      <span v-if="votinglist.length>0" style='font-size:12px'><span
          class="margin-left">{{ votinglist.length }}人未完成投票</span><span @click="votingDiv=true"
                                                                              style='cursor:pointer;color:blue'>查看名单</span></span>
    </el-row>
    <el-table :data="list" row-key="id" border style="width:100%;">
      <el-table-column prop="name" width='100' label="员工姓名" align="center"></el-table-column>
      <el-table-column prop="department" label="部门"></el-table-column>
      <el-table-column prop="month" label="考核月份" width='100' align="center"></el-table-column>
      <el-table-column prop="selfscore" label="自评得分" width='100' align="center"></el-table-column>
      <el-table-column label="自评" width='80' align="center">
        <template slot-scope="scope">
          <span>{{ formatExcellent(scope.row.selfexcellent) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="leaderscore" label="负责人评分" width='100' align="center"></el-table-column>
      <el-table-column label="负责人点评" width='100' align="center">
        <template slot-scope="scope">
          <span>{{ formatExcellent(scope.row.leaderexcellent) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="score" label="最终得分" width='100' align="center"></el-table-column>
      <el-table-column label="最终结果" width='80' align="center">
        <template slot-scope="scope">
          <span>{{ formatExcellent(scope.row.excellent) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" :formatter="formatStatus" width="80"></el-table-column>
      <el-table-column label="投票结果" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.vote>0" style="color:red">{{ scope.row.vote }}条不同意见</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width='80' align="center">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="ass(scope)" size='mini' v-if="scope.row.status != 9">考核</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="isMobile" background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize"
                   @current-change="handleCurrentChange"
                   layout="prev, pager, next" :total="total"></el-pagination>
    <el-pagination v-else background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize"
                   @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :title='crntname' :visible.sync="assDiv" :show-close="false" width='100%' :close-on-click-modal="false">
      <el-table :data="alist" row-key="id" border width="100%">
        <el-table-column v-for="(item,index) in trList" :key="index" :label="item.label" :width="item.width"
                         :fixed="item.fixed" :align="item.align">
          <template slot-scope="scope">
            <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1"
                      :type="item.type"></el-input>
            <span v-else v-html='scope.row[item.prop]'></span>
            <!-- <span v-html='scope.row[item.prop]' v-if="item.html==1"></span>
            <template v-else>
              <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
              <span v-else v-html='scope.row[item.prop]'></span>
            </template> -->
          </template>
        </el-table-column>
      </el-table>
      <table class="excellent-table" v-if='needexcellent==1'>
        <tr>
          <th style='width:300px;'>优秀标准</th>
          <th v-for="(item,index) in shenheList" :key="index">
            {{ item.name }}
          </th>
        </tr>
        <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
          <td v-html="item.standard" class="text-left"></td>
          <td v-for="(it,i) in shenheList" :key="i">
            <span v-if="i!='final'">{{ getBeizhu(item.detail, it.uuid) }}</span>
          </td>
        </tr>
        <tr>
          <td>评选结果</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            <el-select size="mini" v-model="item.excellent" v-if="item.uuid=='final'">
              <el-option label='不评' :value='0'></el-option>
              <el-option v-for="(item,index) in excellentTypeList" :key='index' :label='item.excellent_title'
                         :value="item.excellent_id"></el-option>
            </el-select>
            <span v-else>{{ formatExcellent(item.excellent, 1) }}</span>
          </td>
          <td>

          </td>
        </tr>
        <tr>
          <td>备注</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            <el-input type='textarea' v-model='item.beizhu' v-if="item.uuid=='final'"></el-input>
          </td>
        </tr>
      </table>
      <div v-if="voteList.length>0">
        <el-table :data="voteList" row-key="uuid" border>
          <el-table-column prop="name" label="投票人" width="150" align="center"></el-table-column>
          <el-table-column label="投票结果" width="100" align="center">
            <template slot-scope="scope">
              <span v-html="formatVote(scope.row.result)"></span>
            </template>
          </el-table-column>
          <el-table-column label="理由">
            <template slot-scope="scope">
              <span v-html="scope.row.beizhu"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-button @click="submdfy(1)" v-if='canRefuse==1' size='mini' type='info'>暂存</el-button>
        <el-button @click="assDiv=false" size='mini'>返回</el-button>
        <el-button @click="refuse" v-if='canRefuse==1' size='mini' type="danger">驳回</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="leftDiv" :show-close="false" :close-on-click-modal="false">
      <div class="excellentDiv">
        <li v-for='(item,index) in leftlist' :index='index' :key='index'>
          <span>{{ item.name }}</span>
          <span v-if="item.department">({{ item.department }})</span>
        </li>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leftDiv = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="votingDiv" :show-close="false" :close-on-click-modal="false" title="未投票情况统计">
      <div class="text-left">
        <li v-for='(item,index) in votinglist' :index='index' :key='index' class="margin-bottom">
          <div style="font-weight: bold;">{{ item.name }}</div>
          <span v-for="(it,ind) in item.list" :key="ind"
                style="margin-right:10px;white-space: nowrap;color:gray">{{ it }}</span>
        </li>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="votingDiv = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      keyword: '',
      total: 0,
      page: sessionStorage.getItem('final_assess_page') ? parseInt(sessionStorage.getItem('final_assess_page')) : 1,
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      info: [],
      assessinfo: {},
      assDiv: false,
      leftNumber: 0,
      leftDiv: false,
      leftlist: [],
      needexcellent: 1,
      crntname: '',
      crntscope: '',
      excellentlist: [],
      trList: [],
      canRefuse: 0,
      shenheList: {},
      uuid: sessionStorage.getItem('employeeuuid'),
      crntStatus: 0,
      voteList: [],
      votinglist: [],
      votingDiv: false
    };
  },
  computed: {
    score() {
      let temp = [];
      for (let i in this.info) {
        if (this.info[i]['finaldid'] != 0)
          temp.push({
            id: this.info[i]['finaldid'],
            tiid: parseInt(this.info[i].id),
            proportion: this.info[i].proportion,
            score: this.info[i]['finalscore'] ? parseFloat(this.info[i]['finalscore']) : 0,
            beizhu: this.info[i]['finalbeizhu'] ? this.info[i][['finalbeizhu']] : '',
          })
      }
      return temp;
    },
    alist() {
      let temp = {
        id: 0,
        title: '合计',
        readonly: 1,
      }
      let shenhe = [];
      for (let item in this.shenheList) {
        shenhe.push(this.shenheList[item].uuid)
        temp[this.shenheList[item].uuid + 'score'] = 0;
      }
      for (let item in this.info) {
        for (let i in shenhe) {
          temp[shenhe[i] + 'score'] += isNaN(parseFloat(this.info[item][shenhe[i] + 'score'])) ? 0 : parseFloat(this.info[item][shenhe[i] + 'score']);
        }
        // temp.finalscore += isNaN(parseFloat(this.info[item].finalscore)) ? 0 : parseFloat(this.info[item].finalscore);
      }
      for (let item in this.assessinfo.detail) {
        if (this.assessinfo.detail[item].uuid == 'final') {
          this.assessinfo.detail[item].score = temp.finalscore
          break;
        }
      }
      return this.info.concat(temp);
    },
  },
  methods: {
    searchList() {
      this.page = 1;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/finalass/getAssList",
        method: "post",
        data: {
          page: this.page,
          pagesize: this.pagesize,
          keyword: this.keyword,
          status: this.crntStatus
        },
      }).then((res) => {
        this.list = res.data.list.data;
        this.total = res.data.list.total;
        this.leftNumber = res.data.num;
        this.votinglist = res.data.votinglist;
      });
    },
    formatVote(result) {
      switch (result) {
        case 0:
          return '不同意';
        case 1:
          return '<span style="color:green">同意</span>';
        default:
          return '<span style="color:red">未投票</span>';
      }
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
      sessionStorage.setItem('final_assess_page', p);
    },
    formatExcellent(e, full) {
      if (e == -1) return;
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
      if (full) return '不评';
    },
    getBeizhu(item, uuid) {
      for (let i in item) {
        if (i == uuid) {
          return item[i].beizhu
        }
      }
    },
    ass(scope) {
      this.crntscope = scope;
      this.$axios({
        url: this.HOST + "/kaohe/finalass/getAssByUuid",
        method: "post",
        data: {
          muuid: scope.row.muuid
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.info = res.data.list;
          this.assessinfo = res.data.assinfo;
          for (let item in this.assessinfo.detail) {
            this.assessinfo.detail[item].excellent = parseInt(this.assessinfo.detail[item].excellent)
          }
          this.needexcellent = res.data.need_excellent;
          this.crntname = scope.row.name;
          this.assDiv = true;
          this.excellentlist = res.data.excellentlist;
          this.trList = res.data.trList;
          this.canRefuse = res.data.canRefuse;
          this.shenheList = res.data.shenheList;
          this.voteList = res.data.vote;
          console.log(this.score)
        }
      });
    },
    refuse() {
      this.$confirm(
          '确定要驳回考核吗？',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/kaohe/finalass/finalrefuse",
          method: "post",
          data: {
            aid: this.assessinfo.id,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.assDiv = false;
            this.$message({
              type: "info",
              message: "操作成功",
            });
            this.getlist();
          }
        });
      });
    },
    submdfy(status) {
      this.$axios({
        url: this.HOST + "/kaohe/finalass/saveAss",
        method: "post",
        data: {
          info: this.assessinfo,
          score: this.score,
          status: 1,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message({
            type: 'success',
            message: res.data.info
          })
          this.assDiv = false;
          this.crntscope.row.score = res.data.score;
          this.crntscope.row.status = status;
          this.crntscope.row.excellent = res.data.excellent;
          this.assessinfo = {};
        }
      });
    },
    finish() {
      this.$confirm(
          '确定要结束考核吗？',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/kaohe/finalass/finish",
          method: "post",
          data: {},
        }).then((res) => {
          if (res.data.status == 1) {
            this.$message({
              type: 'success',
              message: res.data.info
            })
            this.getlist();
          }
        });
      });
    },
    showLeft() {
      this.$axios({
        url: this.HOST + '/kaohe/finalass/getLeftList',
        method: 'post',
        data: {}
      }).then(res => {
        if (res.data.status == 1) {
          this.leftlist = res.data.list;
          this.leftDiv = true;
        }
      })
    },
    formatStatus(row) {
      switch (row.status) {
        case 1:
          return '暂存';
        case 9:
          return '完成';
      }
    }
  },
  created: function () {
    this.getlist();
  },
};
</script>